import * as React from 'react'
import {
  Typography,
  CircularProgress,
  CircularProgressProps,
  Box,
} from '@mui/material'

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number; fontSize?: number | string }
) {
  return (
    <Box position={'relative'} display={'inline-flex'}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          style={{ fontWeight: 'bolder', fontSize: props.fontSize || 9 }}
          variant="caption"
          component="div"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  )
}

export default CircularProgressWithLabel
